<template>
    <router-view></router-view>
</template>
<script>
export default {
    mounted(){
        let menus = [
            {
                LangKey: 'setting',
                Link: '/setting'
            },
            {
                LangKey: 'users',
                Link: '/setting/users'
            },
            {
                LangKey: 'user_group',
                Link: '/setting/groups'
            }
        ];
        this.$store.commit('setMenu', menus);
    },
    destroyed(){
        this.$store.commit('setMenu', []);
    }
}
</script>